import { Injectable } from '@angular/core';
import { UrlSerializer, UrlTree, DefaultUrlSerializer } from '@angular/router';

@Injectable()
export class SearchQuerySerializer implements UrlSerializer {

  constructor(
    private defaultSerializer: DefaultUrlSerializer
  ) { }

  parse(url: string): UrlTree {
    // Change plus signs to encoded spaces
    url = url.replace(/\+/g, '%20');
    // Use the default serializer that you can import to just do the
    // default parsing now that you have fixed the url.
    return this.defaultSerializer.parse(url);
  }

  serialize(tree: UrlTree): string {
    // Use the default serializer to create a url and replace any spaces with + signs
    return this.defaultSerializer.serialize(tree).replace(/%20/g, '+');
  }

}
